import styled from "@emotion/styled";

import { sizeToken } from "../../Internals/ThemeProvider/CandyTheme/ThemeBuilder/ICandyTheme";
import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

import { MessageBoxType } from "./MessageBoxType";

export const Root = styled.div<{ type: MessageBoxType }>(props => ({
    padding: "15px 20px",
    marginTop: 30,
    marginBottom: 10,
    backgroundColor:
        props.type === MessageBoxType.errorLog
            ? theme(props).semanticColors.warning.backgroundColor
            : props.type === MessageBoxType.success
              ? theme(props).semanticColors.success.backgroundColor
              : props.type === MessageBoxType.error
                ? theme(props).semanticColors.danger.backgroundColor
                : undefined,
}));

export const Message = styled.p({
    margin: `${sizeToken(1)}px 0 0`,
});
